<div class="ha-how-you-eat-section section-wrapper">
	<div id="lifestyle-how-you-eat">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-eat.heading'">How You Eat</span>
		</div>
		<div class="form-group" [formGroup]="howYouEatForm">
			<div class="form-field">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.how-you-eat.form-fields.servingsOfFruitsVegetables'">
					On a typical day, how many servings of whole fruits and vegetables do you eat?
				</div>
				<mat-form-field appearance="fill">
					<mat-label
						><span
							[translate]="
								'wellness.health-assessment-new.lifestyle.how-you-eat.form-fields.servingsOfFruitsVegetables-placeholder'
							"
							>Fruits/vegies servings (daily)</span
						></mat-label
					>
					<input appAutofocus matInput formControlName="servingsOfFruitsVegetables" [readonly]="readOnly" />
				</mat-form-field>
			</div>

			<div class="form-field">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.how-you-eat.form-fields.howManyFastSugaryFood'">
					Over the last two weeks, how often have you consumed fast food, sugary drinks, or packaged foods?
				</div>
				<mat-form-field appearance="fill">
					<mat-label
						><span
							[translate]="
								'wellness.health-assessment-new.lifestyle.how-you-eat.form-fields.howManyFastSugaryFood-placeholder'
							"
							>Fast food servings (last two weeks)</span
						></mat-label
					>
					<input matInput formControlName="howManyFastSugaryFood" [readonly]="readOnly" />
				</mat-form-field>
			</div>

			<div class="form-field">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.how-you-eat.form-fields.followedAnyDiets'">
					Have you followed any diets in the past?
				</div>
				<mat-radio-group
					formControlName="followedAnyDiets"
					[disabled]="readOnly"
					[(ngModel)]="howYouEatData.followedAnyDiets">
					<mat-radio-button [value]="true">
						<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-eat.form-fields.option-yes'">Yes</span>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-eat.form-fields.option-no'">No</span>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div *ngIf="howYouEatData?.followedAnyDiets" class="diet-input-field">
				<mat-form-field appearance="fill">
					<mat-label
						><span [translate]="'wellness.health-assessment-new.lifestyle.how-you-eat.form-fields.dietDetails'"
							>Past diets</span
						></mat-label
					>
					<input matInput formControlName="dietDetails" [readonly]="readOnly" />
				</mat-form-field>
			</div>
		</div>
	</div>
</div>
<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="next()">
	<button class="button button-medium" mat-button>
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
	</button>
</div>
